import { refreshCartFragments, isBtnLocked } from "../../utils/cart-fragments";
import celebrate from "../../utils/celebrate";

// Take over every .ajax_add_to_cart click from WooCommerce's own add-to-cart.js.
//
// Products are "sold individually" (see class-cart.php: woocommerce_is_sold_individually),
// so adding one that's already in the cart makes WooCommerce answer with an
// error + a redirect to the product page. We don't want that: the button should
// always just push the product and open the side cart, which already reflects
// the real cart contents (via fragments). If it's already there, nothing
// changes and we still open the cart.
export default function initCartSingle() {
    const openSideCart = () => {
        if (window.jQuery) window.jQuery(document.body).trigger('added_to_cart');
    };

    // Capture phase: run before WooCommerce's delegated bubbling handler.
    document.addEventListener(
        'click',
        (e) => {
            const btn = e.target.closest('.ajax_add_to_cart');
            if (!btn) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            const productId = btn.dataset.product_id;
            if (!productId || isBtnLocked(btn)) return;

            btn.classList.add('loading');
            // A wave of squares leaves the button's shape.
            celebrate(btn);

            const body = new FormData();
            body.append('product_id', productId);
            body.append('quantity', btn.dataset.quantity || 1);

            fetch('/?wc-ajax=add_to_cart', { method: 'POST', body })
                .then(() => refreshCartFragments())
                .then(() => openSideCart())
                .finally(() => btn.classList.remove('loading'));
        },
        true
    );
}
